/**
 * GiveToCharityWidget
 *
 * Dashboard widget that displays charity search and recent/favourite charities.
 * Self-contained - handles navigation and search.
 */
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { createSearchParams, useNavigate } from 'react-router-dom'

import { CharitiesSearchInput, RecentAndFavouriteCharities, Stack, Text } from '../..'

export function GiveToCharityWidget() {
  const navigate = useNavigate()
  const { fundId } = useParams()
  const [searchText, setSearchText] = useState('')

  const onSubmit = (event) => {
    event.preventDefault()
    const search = createSearchParams({ s: searchText }).toString()
    navigate({ pathname: `/funds/${fundId}/grant/search-by-text`, search })
  }

  return (
    <Stack alignItems="stretch">
      <Text.H2>Give To Charity</Text.H2>

      <form onSubmit={onSubmit}>
        <CharitiesSearchInput onChange={(e) => setSearchText(e.target.value)} />
      </form>

      <RecentAndFavouriteCharities />
    </Stack>
  )
}
